// Custom hook for Google Maps integration
import { useState, useEffect, useRef } from 'react';
import googleMapsService from '../services/googleMapsService';

export const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMaps = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        await googleMapsService.loadGoogleMaps();
        setIsLoaded(true);
      } catch (err) {
        setError(err.message);
        console.error('Failed to load Google Maps:', err);
      } finally {
        setIsLoading(false);
      }
    };

    if (googleMapsService.isGoogleMapsLoaded()) {
      setIsLoaded(true);
    } else {
      loadMaps();
    }
  }, []);

  return { isLoaded, isLoading, error };
};

export const useAutocomplete = (inputRef, options = {}) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const { isLoaded } = useGoogleMaps();
  const optionsRef = useRef(options);
  optionsRef.current = options;

  useEffect(() => {
    if (isLoaded && inputRef.current && !autocomplete) {
      try {
        const autocompleteInstance = googleMapsService.createAutocomplete(
          inputRef.current, 
          optionsRef.current
        );
        setAutocomplete(autocompleteInstance);
      } catch (error) {
        console.error('Failed to create autocomplete:', error);
      }
    }
  }, [isLoaded, inputRef, autocomplete]);

  return autocomplete;
};
